import { cx } from "@/utils";

import styles from "./IconBall.module.css";

export type IconBallProps = {
  className?: string;
  icon: IconComponent;
} & React.HTMLProps<HTMLDivElement>;

const IconBall: React.FunctionComponent<IconBallProps> = ({
  className,
  icon: Icon,
  ...props
}) => {
  return (
    <div className={cx(styles.root, className)} {...props}>
      <Icon />
    </div>
  );
};

export default IconBall;
